import { render, staticRenderFns } from "./ClQuestion.vue?vue&type=template&id=469c602b&scoped=true&"
import script from "./ClQuestion.vue?vue&type=script&lang=ts&"
export * from "./ClQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./ClQuestion.vue?vue&type=style&index=0&id=469c602b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469c602b",
  null
  
)

export default component.exports